import SidebarItemLabel_vue_vue_type_script_setup_true_lang_default from "./SidebarItemLabel.vue_vue_type_script_setup_true_lang.js";
//#region src/components/SidebarItemLabel.vue
var SidebarItemLabel_default = SidebarItemLabel_vue_vue_type_script_setup_true_lang_default;
//#endregion
export { SidebarItemLabel_default as default };

//# sourceMappingURL=SidebarItemLabel.vue.js.map